export default __webpack_public_path__ + "static/media/tpc_ira.3c49b077.svg";